module.exports = __webpack_public_path__ + "static/media/kaspay-pro-banner.a5317a92.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/kaspay-pro-banner.png
// module id = 651
// module chunks = 8